import './contact-agent-phone.css';
import { IBranding } from '../../models/branding.model';
import { isNullOrUndefinedOrBlank } from '../../util/isNullOrUndefinedOrBlank';
import { iconPhone } from '../../util/icons';

export interface ContactAgentPhoneProps {
  branding: IBranding;
  showIcon?: boolean;
}

export const ContactAgentPhone = (props: ContactAgentPhoneProps) => {
  return (
    <div className="contact-agent-phone">
      {!isNullOrUndefinedOrBlank(props.branding.agent1_name) &&
        <div>
          <a href={'tel:' + props.branding.agent1_phone} style={{ textDecoration: 'none', color: 'var(--default-font-color)' }} >
            {props.showIcon && iconPhone} Call {props.branding.agent1_name}, {props.branding.agent1_designation} of <span className="nobr">{props.branding.brokerage_name}</span> at <span className="nobr">{props.branding.agent1_phone}</span>
          </a>
        </div>
      }
      {!isNullOrUndefinedOrBlank(props.branding.agent2_name) &&
        <div>
          <a href={'tel:' + props.branding.agent2_phone} style={{ textDecoration: 'none', color: 'var(--default-font-color)' }} >
            {props.showIcon && iconPhone} Call {props.branding.agent2_name}, {props.branding.agent2_designation} of <span className="nobr">{props.branding.brokerage_name}</span> at <span className="nobr">{props.branding.agent2_phone}</span>
          </a>
        </div>
      }
    </div>
  );
};
